angular.module('env.data.services.serverInfo', [])

    .service('serverInfoService', function ($rootScope, $log, $q, $http, authService, appReloadService) {
        var _this = this;
        
        /**
         * Gets server version
         * @returns {Promise}
         */
        _this.getVersion = function () {
            var token = authService.getToken();
            if (!token) {
                $log.error('Can not fetch server info when not authorized.');
                return '';
            }
            var config = { headers: { Authorization: token } };

            return $http
                .get(om.config.build.baseUrl + "/info/version", config)
                .then(
                    function (resp) {
                        return resp.data ? resp.data : '';
                    },
                    function (error) {
                        $log.error('Can not fetch server info. Error: ' + error);
                        return $q.reject(error);
                    });
        };

        _this.checkServerVersionAndAskReloadIfNeeded = function () {
            return _this.getVersion()
                .then(function (serverCurrentVersion) {
                    if (!$rootScope.serverVersionNumber) {
                        $rootScope.serverVersionNumber = serverCurrentVersion;
                    }
                    //We want to know the current server version to decide if we need to refresh our currently loaded SPA if the
                    //current version is older. Once we reload the page - all the scripts and everything will be reloaded due to
                    //version specific urls from the index page
                    if ($rootScope.serverVersionNumber !== serverCurrentVersion) {

                        $log.debug(
                            "Server new version %s deployment detected [Old version: %s]. Recommending user to reload the current tab.",
                            serverCurrentVersion,
                            $rootScope.serverVersionNumber);

                        //Trigger modal dialog to be shown asking for reload
                        appReloadService.show();
                    }
                });
        };

        return _this;
    })

;
